module.exports = __webpack_public_path__ + "img/marisol-malibu-zer-2-home.88b63a8e.jpg";